@if (loaderService.isLoading.value) {
  <div class="wrapperStyle">&nbsp;</div>
}
@if (!isCostConfirmed && !isPendingRevision && !isCancelled) {
  <h2 class="text-center">Submit Kaizen for CMD Review</h2>
}

@if (isCostConfirmed || isPendingRevision || isInProgress || isCancelled) {
  <div id="wrapper" class="col-12 rounded-2">
    <div class="text-center">
      <h2 >Update Kaizen Plan </h2><br>
    </div>
    <span class="kaizen-status-box col-12">
      <strong>Kaizen Status: {{this.kaizenStatusDisplayString}}</strong>
      @if (isPendingRevision) {
        <div><br>Requested Revision By: {{this.CreateKaizen.pendingRevisionBy}}</div>
      }
      @if (isCostConfirmed) {
        <div><br>Cost Confirmed By: {{this.CreateKaizen.costConfirmedBy}}</div>
      }
      @if (isPendingRevision) {
        <div>Reason for Requested Revision: {{this.CreateKaizen.cmdReviewerComments}}</div>
      }
      @if (isCancelled) {
        <div><br>Reason for Cancellation: {{this.CreateKaizen.cancellationReason}}</div>
      }
      <hr />
      Submitted on: {{this.createdDisplayDate |  date:'MM/dd/yyyy  h:mm a' }} {{this.timeZoneAbbreviation}}<br>
      @if (isPendingRevision) {
        <span>Requested Revision on: {{this.pendingRevisionDisplayDate |  date:'MM/dd/yyyy  h:mm a'}}  {{this.timeZoneAbbreviation}}<br></span>
      }
      @if (isCostConfirmed) {
        <span>Cost Confirmed on: {{this.costConfirmedDisplayDate |  date:'MM/dd/yyyy  h:mm a'}}  {{this.timeZoneAbbreviation}}<br></span>
      }
      @if (isInProgress) {
        <span>Progress Changed on: {{this.costConfirmedDisplayDate |  date:'MM/dd/yyyy  h:mm a'}}  {{this.timeZoneAbbreviation}}<br></span>
      }
      @if (isCancelled) {
        <span>Cancelleded on: {{this.progressChangedDisplayDate |  date:'MM/dd/yyyy  h:mm a'}}  {{this.timeZoneAbbreviation}}<br></span>
      }
      Last updated: {{this.modifiedDisplayDate |  date:'MM/dd/yyyy  h:mm a '}} {{this.timeZoneAbbreviation}}
    </span>
  </div>
}
<br>
  @if (editKaizenId > 0 ) {
    <div>
      <h3 class="kaizenId-label">Kaizen Num : K{{CreateKaizen.kaizenNumber}}</h3>
    </div>
  }
  <mat-stepper class="example-stepper" [orientation]="(stepperOrientation | async)!" #stepper [selectedIndex]="0">
    <mat-step [stepControl]="firstFormGroup" label="Contacts & Location">

      <app-contact [CreateKaizen]="CreateKaizen" (emitKaizenContact)="getContactTab($event)"></app-contact>
      <app-location  (emitKaizenLocation)="getLocationTab($event)" ></app-location>
      <div class="col-sm-12">
        <button mat-flat-button  (click)="cancel()" type="button" color="primary" class="cssCustomButton" >Cancel</button>
        @if (CreateKaizen.kaizenStateID == 1) {
          <button mat-flat-button   [disabled]="!firstFormValid"
          (click)="saveForm(1)" color="primary" class="cssCustomButton">Save for later</button>
        }
        @if (CreateKaizen.kaizenStateID == 1 && editKaizenId==0 && showNextButton) {
          <button mat-flat-button  [disabled]="!firstFormValid"
          (click)="saveForm(10)" color="primary" class="cssCustomButton">Next</button>
        }
        @if (editKaizenId!=0) {
          <button mat-flat-button [disabled]="!firstFormValid"  (click)="move(1)" color="primary" class="cssCustomButton" >Next</button>
        }
        @if ((isAdmin)) {
          <button mat-flat-button  (click)="onRecalc($event)"  color="primary" class="cssCustomButton">Recalculate</button>
        }
      </div>

    </mat-step>
    <mat-step [stepControl]="secondFormGroup" label="Yokoten & Ringi">


      <app-yokoten [CreateKaizen]="CreateKaizen" (emitKaizenYokoten)="getYokotenTab($event)"></app-yokoten>
      <div class="card m-3">
        <app-ringi [CreateKaizen]="CreateKaizen" (emitKaizenRingi)="getRingiTab($event)"></app-ringi>
      </div>
      <br>
        <div  class="col-sm-12">
          <button mat-flat-button  matStepperPrevious color="primary" class="cssCustomButton" class="cssCustomButton">Back</button>
          <button mat-flat-button (click)="cancel()" type="button" color="primary" class="cssCustomButton">Cancel</button>
          @if (CreateKaizen.kaizenStateID == 1) {
            <button mat-flat-button (click)="saveForm(2)"
            color="primary">Save for later</button>
          }
          <button mat-flat-button (click)="move(2)" color="primary"
          [disabled]="!yokotenTabValid || ringiTabInvalid">Next</button>

        </div>

      </mat-step>
      <mat-step label="Kaizen Details">

        <div class="card m-3">
          <h5 class="card-header">Kaizen Description <span class="legend-label">{{requiredLegend}}</span></h5>
          <div class="card-body">

            <app-description [CreateKaizen]="CreateKaizen" (emitKaizenDescription)="getDescriptionTab($event)"></app-description>

            <app-attachment [InputKaizenID]="this.editKaizenId"></app-attachment>

          </div>
        </div>

        <div  class="col-sm-12">
          <button mat-flat-button  matStepperPrevious  color="primary" class="cssCustomButton">Back</button>
          <button mat-flat-button   (click)="cancel()" type="button"  color="primary" class="cssCustomButton">Cancel</button>
          @if (CreateKaizen.kaizenStateID == 1) {
            <button mat-flat-button  (click)="saveForm(3)" color="primary" class="cssCustomButton">Save for later</button>
          }
          <button mat-flat-button  (click)="move(3)" color="primary"  [disabled]="descriptionTabInvalid" class="cssCustomButton">Next</button>

        </div>

      </mat-step>

      <mat-step  label="Rank Information">
        <app-rank [CreateKaizen]="CreateKaizen" (emitKaizenRank)="getRankTab($event)"></app-rank>
        <div><br>
          <button mat-flat-button  matStepperPrevious  color="primary" class="cssCustomButton">Back</button>
          <button mat-flat-button   (click)="cancel()" type="button"  color="primary" >Cancel</button>
          @if (CreateKaizen.kaizenStateID == 1) {
            <button mat-flat-button  (click)="saveForm(4)" color="primary" class="cssCustomButton" >Save for later</button>
          }
          <button mat-flat-button  (click)="move(4)" color="primary" [disabled]="rankTabInvalid" class="cssCustomButton">Next</button>
        </div>
      </mat-step>

      <mat-step label="Cost Planning">
        <!--  [stepControl]="fifthFormGroup" -->
        <div class="card m-3">
          <h5 class="card-header">Cost Planning <span class="legend-label">{{requiredLegend}}</span></h5>
          <div class="card-body">
            <div class="container">
              <div class="row">

                @for ( paramName of ParamNames; track  paramName) {
                  <div class="col-sm">
                    <strong> {{paramName}}</strong>
                  </div>
                }

              </div>
              <div class="row">
                @for ( paramValue of ParamValues; track  paramValue) {
                  <div class="col-sm">
                    {{paramValue}}
                  </div>
                }

              </div>
            </div>
            <hr>
              <br>

              </div>
              <!--   <div *ngIf="fundamentalAlert || deletedAccountsExist"  style="width: 100%;text-align: right;padding-right: 20px;color: blue;cursor: pointer;" (click)="ViewExistingAc()">Show Deleted Accounts</div>
              <div *ngIf="showDeletedAc" style="border: blue 2px solid;padding-bottom: 30px;">
                <div    style="width: 100%;text-align: right;padding-right: 20px;color: red;cursor: pointer;" (click)="ClosexistingAc()">Hide</div>

                <div innerHtml="{{deletedAccountString}}"></div>
              </div> -->
              <app-accountstab  [CreateKaizen]="CreateKaizen" [reloadKaizenId]="reloadKaizenId"  (emitKaizenAcounts)="getAccountsTab($event)"></app-accountstab>

            </div>

            <div  class="col-sm-12">
              <br><br>
              <button  mat-flat-button  matStepperPrevious  color="primary" >Back</button>
              <button mat-flat-button   (click)="cancel()" type="button"  color="primary" class="cssCustomButton" >Cancel</button>

              <!-- this is used for changing a confirmed Kaizen to in progress -->
              @if (isCostConfirmed || (isPendingRevision && !reApprovalReq)) {
                <button mat-flat-button  matStepperNext  color="primary" type="submit" class="cssCustomButton"
                color="primary" (click)="onSubmit()" >Save</button>
              }
              @if (!isCostConfirmed &&  CreateKaizen.kaizenStateID == 1) {
                <button mat-flat-button  [disabled]="!fifthFormValid"
                (click)="saveForm(55)" color="primary" type="button" class="cssCustomButton">Save for later</button>
              }
              <!-- this is used for submitting a confirmed Kaizen -->
              <!-- <button mat-flat-button   *ngIf="isCostConfirmed && CreateKaizen.kaizenStateID != 1"
            (click)="saveForm(5)" color="primary" type="button" >Submit for Review</button>
            *ngIf="isCostConfirmed && CreateKaizen.kaizenStateID != 1"
            -->
            <!-- this is used for submitting draft Kaizen [disabled]="fifthFormGroup.invalid" *ngIf="!isCostConfirmed && (CreateKaizen.kaizenStateID == 1  || CreateKaizen.kaizenStateID == 3)" -->
            <button  mat-flat-button  matStepperNext mat-add-edit-account-button  color="primary" class="cssCustomButton"
              [disabled]="!fifthFormValid || (isCostConfirmed && !reApprovalReq)"
            type="button" (click)="saveForm(5)"  >Submit for Review</button>

          </div>

        </mat-step>
        <mat-step>
          <ng-template matStepLabel>Done</ng-template>
          <ng-template matStepContent>
            @if (this.formToSave == 5 && kaizenId>0 && !isCostConfirmed) {
              <div>
                <h2>Your Kaizen has been submitted for review!</h2>
                <p>Kaizen ID <b>#K{{ this.CreateKaizen.kaizenNumber }}</b> </p>
                <p>Please keep this Kaizen ID for your records.</p>
                <!-- <p>Confirmation email sent to: {{kaizenCreator}}</p> -->
                <p>Submitted on: {{kaizenCreatedDate | date : 'short'}}</p>
              </div>
            }
            @if (this.formToSave != 5 && kaizenId>0 && !isCostConfirmed) {
              <div>
                <h2>Your draft version is saved successfully.</h2>
                <p>Kaizen ID <b>#K{{ this.CreateKaizen.kaizenNumber }}</b> </p>
                <p>Please keep this Kaizen ID for your records.</p>
              </div>
            }
            @if (isCostConfirmed && kaizenId>0) {
              <div>
                <h2>Your kaizen update has been saved successfully.</h2>
                <p>Kaizen ID <b>#K{{ this.CreateKaizen.kaizenNumber }}</b> </p>
                <p>Please keep this Kaizen ID for your records.</p>
              </div>
            }
            @if (kaizenId==0) {
              <div>
                <H2>Saving..</H2>
              </div>
            }
            <div>
              <button mat-flat-button   routerLink="/kaizens"  color="primary" >Back</button>
            </div>
          </ng-template>
        </mat-step>
      </mat-stepper>
